import React, {useContext, useEffect} from "react";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import css from '../calendarioPresenze_WF.module.css'
import RiepilogoOre from "./RiepilogoOre";
import RiepilogoGiust from "./RiepilogoGiust";
import classNames from "classnames";
import {DateTime} from "luxon";
import RiepilogoIC from "./RiepilogoIC";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda, selectUser} from "@commons/core.slice";
import {IconX} from "@tabler/icons-react";
import {PresenzeContext} from "@commons/hooks/usePresenze";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import AccumuliDiControllo from "./AccumuliDiControllo";

interface RiepilogoTotaliPresenzeProps {
    lavoratore: LavoratorePresenzeRecord,
    week?: StatoWeekPLUSRecord,
    setNextCurrentWeek?: React.Dispatch<React.SetStateAction<number | null>>,
    elencoGiuEvidenza: string[],
    setNextElencoGiuEvidenza: React.Dispatch<React.SetStateAction<string[]>>,
}

export const RiepilogoTotaliPresenze: React.FC<RiepilogoTotaliPresenzeProps> = ({
                                                                                    lavoratore,
                                                                                    week,
                                                                                    setNextCurrentWeek,
                                                                                    elencoGiuEvidenza,
                                                                                    setNextElencoGiuEvidenza,
                                                                                }) => {
    const user: UserCRUDRecord | null = useAppSelector(selectUser); // User corrente
    const isEmployee = user?.userClass === 'EMPLOYEE';

    const {listaGiustificativi, periodo, soloMeseRif, setSoloMeseRif} = useContext(PresenzeContext);
    const toggleGiustificativo = (codice: string) => {
        if (elencoGiuEvidenza.find(c => c === codice))
            setNextElencoGiuEvidenza(elencoGiuEvidenza.filter(c => c !== codice));
        else
            setNextElencoGiuEvidenza(elencoGiuEvidenza.concat([codice]));
    }
    const isHighlighted = (codice: string) => !!elencoGiuEvidenza.find(c => c === codice);

    /*
    *
    * Nota Bene:
    * SE WEEK E' DEFINITA, MI RIFERISCO AL RIEPILOGO SETTIMANALE,
    * ALTRIMENTI, MI RIFERISCO AL RIEPILOGO MENSILE
    *
    * */
    const azienda = useAppSelector(selectAzienda);
    const formattedPeriodo = DateTime
        .fromObject({year: periodo.anno, month: periodo.mese}, {locale: 'it'})
        .toFormat('LLLL yyyy');


    const checkAccumuliWeek = lavoratore.totaliMese!.accumuliCHK && lavoratore.totaliMese!.accumuliCHK.length > 0;

    const showRiepilogoAccumuli = lavoratore.totaliMese && lavoratore.totaliMese.accumuliCHK.length > 0;

    useEffect(() => {
        if (soloMeseRif) {
            // GestionePLUS.updateTotaliMese ??????????
        }
    }, [soloMeseRif]);

    return <div className={`${week ? 'border-2 !border-[#63cde1] p-1.5' : ''} focus:outline-none mb-0.5`}>
        <div className={classNames(css.intestazioneFooter, week ? 'bg-[#CAEDF4]' : 'text-white bg-[#235F6A]')}>
            {lavoratore.cognome}&nbsp;{lavoratore.nome}
            {/* PER RIEPILOGO SETTIMANALE */}
            {week && <>&nbsp;-&nbsp;Week {week.numWeek}<IconX className="h-5 w-5 ml-auto" onClick={() => {
                if (setNextCurrentWeek) setNextCurrentWeek(null)
            }}/>
            </>}
            {/* X RIEPILOGO MENSILE */}
            {!week &&
                <>&nbsp;-&nbsp;
                    <span className="capitalize">{formattedPeriodo}</span>
                    <div className="flex items-center ml-auto">
                        <input
                            type="checkbox"
                            id="gestione.soloMeseRif"
                            name="gestione.soloMeseRif"
                            checked={soloMeseRif}
                            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            onChange={(e) => {
                                setSoloMeseRif(e.target.checked);
                            }}/>
                        <label htmlFor="gestione.soloMeseRif">&nbsp;Totalizza solo il mese di riferimento</label>
                    </div>
                </>
            }
        </div>
        <div className={css.containerRiepiloghi}>
            <div>
                {week && <RiepilogoOre totali={week.totali}/>}
                {!week && <RiepilogoOre totali={lavoratore.totaliMese?.totali || null}/>}
            </div>
            <div>
                {week && <RiepilogoGiust checkWfFlags={false} listaGiustificativi={listaGiustificativi} giustificativi={week.giustificativi}
                                         isHighlighted={isHighlighted} toggleGiustificativo={toggleGiustificativo}/>}

                {/* "Riepilogo ferie e permessi"
                    RIEPILOGOIC è lo stesso componente utilizzato nelle pagine MonitorWF, WF e Presenze - anche se passo solo page='WF' - serve solo per cambiare lo stile se la pagina è MONITORWF*/}
                {!week && <RiepilogoIC idAziendaMaster={azienda?.idAziendaMaster}
                                       idAziendaTabelle={azienda?.idAziendaCDIC} periodo={periodo} idDip={lavoratore.id} page="WF"/>}
            </div>
            {!week && lavoratore.totaliMese && <div className="row-start-2 min-[880px]:row-start-1 min-[880px]:col-start-2">
                <RiepilogoGiust checkWfFlags={false} listaGiustificativi={listaGiustificativi} giustificativi={lavoratore.totaliMese.giustificativi}
                                isHighlighted={isHighlighted} toggleGiustificativo={toggleGiustificativo}/>
            </div>}

            {(!isEmployee && showRiepilogoAccumuli) && <div>
                {(week && checkAccumuliWeek) && <AccumuliDiControllo totali={lavoratore.totaliMese} week={week}/>}
                {!week && <AccumuliDiControllo totali={lavoratore.totaliMese}/>}
            </div>}
        </div>
    </div>
};